/**
 * 快手系应用UA标示
 */
// TODO 海外 APP List 要求不区分大小写判断
export const ksOverseaAppList = ['UVideo', 'Vstatus', 'Kwaigo', 'MvMaster'];

// TODO这么加没个完了，后面想办法搞成自行传入吧
export const ksAppList = [
    'Kwai',
    'Kwai_Lite',
    'Kwai_Pro',
    'livemate',
    'ksthanos',
    'ksNebula',
    'ksnebula',
    'kwaiying',
    'pearl',
    'kinder',
    'm2u',
    'LOLita',
    'XFunCore', // A 站 —— 水母 APP
    'ACVideoCore', // A 站 —— acfun
    'ZIKZAK', // ZIKZAK
].concat(ksOverseaAppList);
